import {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import './UserPanel.scss';
import DropdownModal from '../DropdownModal/DropdownModal';
import ImageLoader from '../ImageLoader/ImageLoader';
export function getUserInitials(userDetails) {
  return (
    userDetails &&
    (userDetails.firstName && userDetails.firstName.charAt(0).toUpperCase()) +
      (userDetails.lastName && userDetails.lastName.charAt(0).toUpperCase())
  );
}

const UserPanel = ({
  isUserPrefsDisplayed,
  userDetails,
  userSettingActions,
  children,
}) => {
  const [isUserPrefsVisible, setIsUserPrefsVisible] = useState(isUserPrefsDisplayed);
  const [userInitials, setUserInitials] = useState(getUserInitials(userDetails));

  useEffect(() => {
    setUserInitials(getUserInitials(userDetails));
  }, [userDetails]);

  useEffect(() => {
    setIsUserPrefsVisible(isUserPrefsDisplayed ?? false);
  }, [isUserPrefsDisplayed]);

  function closeModal() {
    setIsUserPrefsVisible(false);
  }

  function onUserClick() {
    setIsUserPrefsVisible(!isUserPrefsVisible);
  }

  function renderUserInitials() {
    return (
      <div className="userIcon">
        <span className="userInitials">{userInitials}</span>
      </div>
    );
  }

  function renderUserPhoto() {
    return (
      <span className="user-photo">
        {userDetails?.photo ? (
          <ImageLoader src={userDetails?.photo} width="100%" defaultUnloader={renderUserInitials()} />
        ) : (
          renderUserInitials()
        )}
      </span>
    );
  }

  return (
    <div className="UserPanel user-icon-container" data-testid="UserPanel">
      <span
        onClick={onUserClick}
        aria-label="user-panel-container"
        data-testid="user-panel-container"
      >
        {renderUserPhoto()}
      </span>
      <DropdownModal
        customClass="userPrefDlg"
        isVisible={isUserPrefsVisible}
        onModalClose={closeModal}
      >
        <div className="userDetails">
          {renderUserPhoto()}
          <div className="userDetailContent">
            <div
              className="userName"
              title={userDetails && `${userDetails.firstName} ${userDetails.lastName}`}
            >
              {userDetails && `${userDetails.firstName} ${userDetails.lastName}`}
            </div>
            <div className="userEmail" title={userDetails && `${userDetails.emailAddress}`}>
              {userDetails && `${userDetails.emailAddress}`}
            </div>
          </div>
        </div>
        {userSettingActions && <div className="userSettings">{userSettingActions}</div>}
        <div className="userPrefContent">
          <div className="userPrefActions">{children}</div>
        </div>
      </DropdownModal>
    </div>
  );
};

UserPanel.propTypes = {
  isUserPrefsDisplayed: PropTypes.bool,
  userDetails: PropTypes.shape({
    emailAddress: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    photo: PropTypes.string,
  }),
  userSettingActions: PropTypes.node,
};

UserPanel.defaultProps = {
  isUserPrefsDisplayed: false,
};

export default UserPanel;
